"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GetTheAppButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const Badge = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "Badge",
  class: "pl-b1kgr2fx"
});

/**
  * Render get the app button
  * @module GetTheAppButton
  *
  * @param {Object} props React props for for element
  * @param {String} props.id  Unique id
  * @param {String} props._name tracking name for button
  * @param {String} props.href [Required] Url for store download
  * @param {String} props.windowOptions [Required] Target for anchor
  * @param {Object} props.badge [Required] Badge containing url and altText
  * @param {String} props.ariaLabel Aria label describing badge text
  * @returns {React.ReactElement} Get The App component
  * @public
  */
function GetTheAppButton({
  id,
  _name,
  href,
  windowOptions,
  ariaLabel,
  badge
}) {
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    "data-cy": "get-the-app-button",
    id: id,
    target: windowOptions,
    href: href,
    "aria-label": ariaLabel
  }, _patternLibraryUtils.tracking.create(_name, true, true)), /*#__PURE__*/_react.default.createElement(Badge, {
    src: badge.url,
    alt: badge.altText
  }));
}
GetTheAppButton.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  windowOptions: _propTypes.default.string.isRequired,
  ariaLabel: _propTypes.default.string,
  href: _propTypes.default.string.isRequired,
  badge: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    altText: _propTypes.default.string.isRequired
  })
};